export const SURVEY_URL =
    'https://printinsights.qualtrics.com/jfe/form/SV_6u8tQf4GJLKAvbg';
